import {reactSandboxFutureAppBuilder} from '../config/app-builder'

export const reactSandboxFutureHashNavRoute = reactSandboxFutureAppBuilder.createQueryRouteConfig(
  'reactSandboxFutureHashNavRoute',
  {
    path: '/_react_sandbox_future/hash-nav',
    queries: [],
  },
)
